import { render, staticRenderFns } from "./ViewOrganization.vue?vue&type=template&id=20de0b97&scoped=true&"
import script from "./ViewOrganization.vue?vue&type=script&lang=js&"
export * from "./ViewOrganization.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrganization.vue?vue&type=style&index=0&id=20de0b97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20de0b97",
  null
  
)

export default component.exports